<template>
    <b-modal size="lg" v-model="showModal" hide-footer @hidden="cancelar" :title="title">
        <div v-if="loading" class="text-center my-5">
            <b-spinner label="Carregando..."></b-spinner>
        </div>
        <div v-else>
            <div v-if="hasExpiredAcceptedProposals" class="text-center text-danger mb-3">
                Algumas propostas ACEITAS possuem data de validade vencida. Por favor, altere as datas das propostas
                vencidas.
            </div>
            <b-row class="mb-3">
                <b-col>
                    <h5>Orçamento Número: {{ orcamento.numero }}</h5>
                </b-col>
            </b-row>
            <b-table :items="orcamento.itens" :fields="itemFields" responsive="sm" hover :busy="this.busy">
                <template #cell(descricaoResumida)="row">
                    <b-button v-if="row.item.propostas && row.item.propostas.length > 0" size="sm" variant="primary"
                        class="mr-2" @click="toggleDetails(row.item)">
                        <b-icon :icon="row.item._showDetails ? 'dash' : 'plus'"></b-icon>
                    </b-button>
                    {{ row.item.produto ? row.item.produto.descricaoResumida : row.item.descricaoResumida }}
                </template>
                <template #row-details="row">
                    <b-table :items="row.item.propostas" :fields="propostaFields" responsive="sm" hover>
                        <template #cell(status)="data">
                            <b-badge :variant="getBadgeVariant(data.item.status)">
                                {{ data.item.status.descricao }}
                            </b-badge>
                        </template>
                        <template #cell(fornecedor)="data">
                            {{ data.item.fornecedor &&
                                data.item.fornecedor.dadosEmpresa ? data.item.fornecedor.dadosEmpresa.razaoSocial :
                                data.item.razaoSocial }}
                        </template>


                        <template #cell(valorItem)="data">
                            {{ formatCurrency(data.item.valorItem) }}
                        </template>
                        <template #cell(dataValidade)="data">
                            {{ formatDate(data.item.dataValidade) }}
                        </template>
                        <template #cell(acoes)="data">
                            <div v-if="isExpired(data.item.dataValidade)">
                                Vencida
                            </div>
                            <div v-else>
                                <b-form-radio-group v-model="selectedPropostaPerItem[row.item.id]">
                                    <b-form-radio :value="data.item.id" :unchecked-value="null"
                                        :disabled="data.item.status.id === StatusEnum.PROPOSTA_ACEITA.value">
                                    </b-form-radio>
                                </b-form-radio-group>
                            </div>
                        </template>
                    </b-table>
                </template>
            </b-table>
            <div class="d-flex justify-content-center mt-3">
                <b-button id="fecharModal" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                    variant="danger">
                    <div>
                        <b-icon icon="x-circle" />
                    </div>
                    <b-tooltip target="fecharModal" title="Fechar" triggers="hover"></b-tooltip>
                </b-button>
                <b-button id="salvarPropostas" class="ml-2" @click="salvarPropostas" style="height: 30px" pill size="sm"
                    variant="success">
                    <div>
                        <b-icon icon="check-circle" />
                    </div>
                    <b-tooltip target="salvarPropostas" title="Salvar" triggers="hover"></b-tooltip>
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
import StatusEnum from "@/core/utils/StatusEnum"
import ResourceService from "@/core/api/ResourceService"
import TipoRequisicaoCompraEnum from "@/core/utils/TipoRequisicaoCompraEnum"

export default {
    props: {
        autorizacaoSelecionada: {
            type: Object,
            default: null,
        },

        orcamentoId: {
            type: Number,
            required: true
        },
        prefix: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            busy: false,
            showModal: true,
            showErrorModal: false,
            loading: true,
            orcamento: {},
            selectedPropostaPerItem: {},
            itemFields: [
                { key: 'descricaoResumida', label: 'Produto' },
            ],
            propostaFields: [
                { key: 'fornecedor', label: 'Fornecedor' },
                { key: 'valorItem', label: 'Valor' },
                { key: 'quantidade', label: 'Quantidade' },
                { key: 'dataValidade', label: 'Data de Validade' },
                { key: 'status', label: 'Status' },
                { key: 'acoes', label: 'Escolher' }
            ],
            StatusEnum,
            hasExpiredProposals: false,
            hasExpiredAcceptedProposals: false
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, 'Finalizar Propostas']
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/orcamentos`);
        this.$serviceProposta = new ResourceService(`/api/propostas`);
        await this.loadOrcamento()
    },
    methods: {
        async loadOrcamento() {
            try {

                if (this.autorizacaoSelecionada && this.autorizacaoSelecionada.id) {
                    const response = await this.$service.get(`${this.orcamentoId}/completo-validando-autorizacao-compra-direta/${this.autorizacaoSelecionada.id}`)
                    this.orcamento = response.data


                    const itensSemPropostas = this.orcamento.itens.some(item => !item.propostas || item.propostas.length === 0)
                    if (itensSemPropostas) {
                        this.$emit('notify', 'O Orçamento possui itens sem propostas e não pode ser finalizado.')
                        return;
                    }


                    if (this.autorizacaoSelecionada.tipoCompra != TipoRequisicaoCompraEnum.COMPRA_DIRETA.cod) {

                        const itemMenosTresPropostas = this.orcamento.itens.some(item => !item.propostas || item.propostas.length < 3)
                        if (itemMenosTresPropostas) {
                            this.$emit('notify', 'O Orçamento possui itens com menos de três propostas e não pode ser associado a uma autorização.')
                            return;
                        }

                    }
                }
                else {
                    const response = await this.$service.get(`${this.orcamentoId}`)
                    this.orcamento = response.data
                    const itensSemPropostas = this.orcamento.itens.some(item => !item.propostas || item.propostas.length === 0)
                    if (itensSemPropostas) {
                        this.$emit('notify', 'O Orçamento possui itens sem propostas e não pode ser finalizado.')
                        return;
                    }

                }

                this.orcamento.itens.forEach(item => {
                    const propostaAceita = item.propostas.find(proposta => proposta.status.id === StatusEnum.PROPOSTA_ACEITA.value)
                    if (propostaAceita) {
                        this.$set(this.selectedPropostaPerItem, item.id, propostaAceita.id)
                    }
                })
                this.showModal = true

                this.hasExpiredProposals = this.orcamento.itens.some(item =>
                    item.propostas && item.propostas.some(proposta => this.isExpired(proposta.dataValidade))
                );
                this.hasExpiredAcceptedProposals = this.orcamento.itens.some(item =>
                    item.propostas && item.propostas.some(proposta =>
                        proposta.status.id === StatusEnum.PROPOSTA_ACEITA.value && this.isExpired(proposta.dataValidade)
                    )
                );

            } catch (error) {
                this.$emit('notify', error.response.data);
            } finally {
                this.loading = false;
            }
        },
        getBadgeVariant(status) {
            if (status.descricao === 'ACEITO') {
                return 'success'
            } else if (status.descricao === 'RECUSADO') {
                return 'danger'
            } else {
                return 'secondary'
            }
        },
        async salvarPropostas() {
            const propostasIds = Object.values(this.selectedPropostaPerItem)
            if (propostasIds.length === 0) {
                this.$bvToast.toast('Nenhuma proposta selecionada.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
                return
            }
            try {
                this.busy = true;
                await Promise.all(propostasIds.map(id => this.$serviceProposta.put(`${id}/status/${this.autorizacaoSelecionada.id}`, { statusId: StatusEnum.PROPOSTA_ACEITA.value })))
                this.finalizar()
            } catch (error) {
                this.busy = false;
                this.$bvToast.toast('Erro ao finalizar propostas.', {
                    title: 'Erro',
                    variant: 'danger',
                    solid: true
                })
            }
        },
        isExpired(date) {
            if (!date) return true
            const today = new Date().toISOString().split('T')[0]
            return date < today
        },
        toggleDetails(item) {
            this.$set(item, '_showDetails', !item._showDetails)
        },
        cancelar() {
            this.$emit('close')
        },

        finalizar() {
            this.$emit('finalizar')
        },
        fecharErroModal() {
            this.showErrorModal = false
            this.cancelar()
        },
        formatCurrency(value) {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
        },
        formatDate(date) {
            if (!date) return ''
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
    }
}
</script>
